import React from 'react';
import { FormItemsDeserialize } from './utils';
import { BuilderContext } from '../../admin-console/admin-console-content-pages/admin-console-volunteer-profile/form-builder/task-list/task-items/task-item-fields/types';
import { FormListItem } from './FormListItem';

export const FormListItemContext = React.createContext({
  setFieldValue: (_unusedfield: string, _unusedvalue: any, _unusedshouldValidate?: boolean | undefined) => {},
  draggingId: '',
  setDraggingId: (_unusednewDraggingId: string) => {},
  formItems: {
    allIds: [] as Array<string>,
    byId: {},
    byTrigger: {},
    byTriggerOption: {},
  } as FormItemsDeserialize,
});

interface FormListItemContextProviderProps {
  children: React.ReactElement;
  formItems: FormItemsDeserialize;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void;
}

export const FormListItemContextProvider = ({
  children,
  formItems,
  setFieldValue,
}: FormListItemContextProviderProps) => {
  const [draggingId, setDraggingId] = React.useState('');

  const builderContextValue = React.useMemo(
    () => ({
      items: formItems,
      draggingId,
      renderItem: (itemId: string, index: number) => <FormListItem formItemId={itemId} index={index} />,
      itemLabel: 'form fields',
    }),
    [formItems, draggingId]
  );

  return (
    <FormListItemContext.Provider
      value={{
        draggingId,
        setDraggingId,
        formItems,
        setFieldValue,
      }}
    >
      <BuilderContext.Provider value={builderContextValue}>{children}</BuilderContext.Provider>
    </FormListItemContext.Provider>
  );
};
